var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5209.278 2388)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5209 -2388)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm0,11.357A5.357,5.357,0,1,1,21.357,16,5.357,5.357,0,0,1,16,21.357Z",
    transform: "translate(-10.278 -10)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.573,21a.327.327,0,0,1,.323.323V25.2a.323.323,0,1,1-.646,0V21.323A.327.327,0,0,1,23.573,21Z",
    transform: "translate(-17.573 -16.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.516,
    cy: 0.516,
    r: 0.516,
    transform: "translate(5.484 2.913)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolTip);
export default __webpack_public_path__ + "static/media/tool_tip.01a541c9b290db532e7eb23de74b93c6.svg";
export { ForwardRef as ReactComponent };